'use client'
import { useState, useRef } from 'react'
import Flickity from 'react-flickity-component'
import FullNews from './FullNews'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import 'styles/slider.css'

const Slider = ({ items = [] }) => {
  const [indexLive, setIndexLive] = useState(0)
  const flkty = useRef(null)

  return (
    <div className="relative cursor-grab overflow-hidden">
      <button
        className="absolute h-full z-10 -left-4 hidden md:block"
        onClick={() => {
          flkty?.current?.previous()
        }}
      >
        <ChevronLeftIcon className="w-32 text-white" />
      </button>
      <Flickity
        className="w-full"
        options={{ initialIndex: 0, autoPlay: 5000, wrapAround: true }} // takes flickity options {}
        flickityRef={(flickity) => {
          flickity.on('settle', setIndexLive)
          flkty.current = flickity
        }}
      >
        {items.map((item, idx) => (
          <FullNews
            key={idx}
            img={item.imagen}
            mobImg={item.img_movil}
            title={item.titulo}
            link={item.link}
            position={item.posicion}
          />
        ))}
      </Flickity>
      <div className="absolute bottom-4 lg:bottom-10 w-full flex justify-center gap-4 mt-10">
        {[...Array(items.length)].map((_, idx) => (
          <div key={idx}>
            <div
              className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full border border-white ${
                indexLive === idx ? 'bg-white' : 'bg-blue'
              }`}
            />
          </div>
        ))}
      </div>
      <button
        className="absolute top-0 h-full z-10 -right-4 hidden md:block"
        onClick={() => {
          flkty?.current?.next()
        }}
      >
        <ChevronRightIcon className="w-32 text-white" />
      </button>
    </div>
  )
}

export default Slider
